import { render, staticRenderFns } from "./ShopSidebarTwo.vue?vue&type=template&id=643ee8d9&"
import script from "./ShopSidebarTwo.vue?vue&type=script&lang=js&"
export * from "./ShopSidebarTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643ee8d9')) {
      api.createRecord('643ee8d9', component.options)
    } else {
      api.reload('643ee8d9', component.options)
    }
    module.hot.accept("./ShopSidebarTwo.vue?vue&type=template&id=643ee8d9&", function () {
      api.rerender('643ee8d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/shop/sidebar/ShopSidebarTwo.vue"
export default component.exports